import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00ceab",
        secondary: "#b0bec5"
      },
      dark: {
        primary: "#00ceab",
        secondary: "#b0bec5"
      }
    }
  }
});
